<template>
  <div class="salaries-page">
    <template v-if="$auth.loggedIn || $device.isCrawler">
      <Header />
      <SalariesHeader />
      <SalariesContent />
      <SalariesFooter />
      <Footer />
    </template>
    <template v-else>
      <div class="salaries-page__back">
        <img
          class="salaries-page__back-img"
          src="../components/partials/salaries/images/bg-signup@2x.jpg"
          alt="Sales comp guide"
        />
      </div>
      <SalariesHeader />
    </template>
  </div>
</template>

<script>
import SalariesContent from '@/components/partials/salaries/salaries-content/SalariesContent.vue';
import BravadoTheme from '@/components/common/BravadoTheme/BravadoTheme';
import { SIGN_UP_MODAL } from '@/constants/dynamicModals';
import SalariesHeader from '~/components/partials/salaries/SalariesHeader';
import SalariesFooter from '~/components/partials/salaries/SalariesFooter';
import { warRoomStates } from '~/components/partials/war-room/constants';
import Header from '~/components/global/Header/Header';
import Footer from '~/components/global/Footer/Footer';
import { WAR_ROOM_POSTS_TAB_MYFEED_PAGE } from '~/constants';

export default {
  name: 'SalariesPage',
  components: {
    SalariesHeader,
    SalariesFooter,
    SalariesContent,
    BravadoTheme,
    Header,
    Footer,
  },
  layout: 'clear',
  colorMode: 'dark',
  head() {
    return this.$seo({
      title: 'State of Sales Compensation [2022]',
      description: `The sales talent market has never been more competitive. Sales compensation has changed dramatically in the past 6 months. See how your sales organization compares.`,
    });
  },
  computed: {
    isInOnboardingState() {
      return this.$auth.user?.warRoomState === warRoomStates.IN_ONBOARDING;
    },
  },
  mounted() {
    if (!this.$auth.loggedIn && !this.$device.isCrawler) {
      this.$modal.show(SIGN_UP_MODAL, { persistent: true });
    }
  },
  methods: {
    handleToOnboarding() {
      window.location.href = `/b2c/?${new URLSearchParams(this.$route.query).toString()}`;
    },
    handleToWarRoom() {
      this.$utils.routeReplaceWithQuery(WAR_ROOM_POSTS_TAB_MYFEED_PAGE);
    },
  },
};
</script>

<style lang="scss" scoped>
.salaries-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: var(--white);
  // overflow: hidden;

  position: relative;

  &__back {
    position: absolute;
    width: 100%;
    height: 100%;
  }

  &__back-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
</style>
